export default function determineLfcEnv(nodeEnv) {
  const { hostname, href } = window.location;

  if (
    nodeEnv === "development" ||
    nodeEnv === "test" ||
    // local .NET environment
    href.toLowerCase().indexOf("nopperoyal.public") > -1 ||
    // test environment(s)
    hostname.indexOf("skbygg.com") > -1
  ) {
    console.log("lfc-frontend: Running in local or test environment");
    return "test";
  } else {
    return "prod";
  }
}
